export function isEmpty(value) {
  return (
    value === undefined
    || value === null
    || (typeof value === 'object' && Object.keys(value).length === 0)
    || (typeof value === 'string' && value.trim().length === 0)
  );
}

export function firstLetterWord(names) {
  if (isEmpty(names)) {
    return '';
  }
  const letters = names.toUpperCase().split(' ').map(name => name.charAt(0));
  return letters.splice(0, 2).join('');
}

export default {
  isEmpty,
  firstLetterWord,
};
